import { types } from 'mobx-state-tree';
const ListDetailsProps = {
    id: types.optional(types.string, ''),
    accountId: types.optional(types.string, ''),
    archived: types.optional(types.boolean, false),
    createdAt: types.maybeNull(types.string),
    createdByFullName: types.maybeNull(types.string),
    type: types.maybeNull(types.string),
    privacy: types.maybeNull(types.string),
    listKey: types.optional(types.string, ''),
    name: types.optional(types.string, ''),
    createdByUserId: types.optional(types.maybeNull(types.number), 0),
    total: types.optional(types.number, 0),
    updatedAt: types.maybeNull(types.string),
    userId: types.optional(types.maybeNull(types.number), 0),
};
const ListDetails = types.model(ListDetailsProps);
export default ListDetails;
